<template>
  <div class="ReponsePage-wrap" data-app>
    <div class="page-wrap" ref="main-screen">
      <transition-group name="slideUp">
        <!-- 標題(回應) -->
        <div class="pageTitle" key="pageTitle" v-show="showUp">
          結果出爐！轉化思維與你產生連結的是
          <span class="titleName">{{ titleName }}</span><br />
          針對這次的故事，他曾說...
        </div>
        <!-- 背景波浪 -->
        <div class="textBgWave-component" key="textBgWave" v-show="showUp">
          <textBgWave :color="'rgba(253,230,168,1)'" :width="'340px'" />
        </div>
        <!-- 主要內容(黃色雲朵區塊) -->
        <div class="mainContent-wrap" key="mainContent" v-show="showUp">
          <!-- 文字內容 -->
          <div class="mainContent" v-html="reponseContent"></div>
          <!-- 播放與暫停鍵 -->
          <div class="bg-heart" @click="playResponseMedia()">
            <div :class="playResponse ? 'bg-pause' : 'bg-play-pink'"></div>
          </div>
          <!-- 重播鍵 -->
          <div class="bg-replay" @click="replayResponseMedia()"></div>
        </div>
        <!-- 粉紅色小生物 -->
        <div v-show="playResponse" class="bg-pink-animal" key="bg-pink-animal"></div>
      </transition-group>

      <transition-group name="fade">
        <!-- 波浪動畫 -->
        <ResponseWave v-show="showWave" class="ResponseWave-component" key="ResponseWave" />
        <!-- 波浪動畫下面的區塊 -->
        <div v-show="showWave" class="waveContent" key="waveContent">
          <transition-group name="slideDown">
            <!-- 全部內容 -->
            <template v-if="showDown">
              <!-- 20210726 關閉編輯 STT 視窗 -->
              <!-- 標題(回顧) -->
              <!-- <div class="reviewTitle myRow items-center" key="reviewTitle"> -->
                <!-- 編輯後收藏你的錄音文字： -->
              <!-- </div> -->
              <transition-group name="slideIn" key="slideIn">
                <!-- 20210726 關閉編輯 STT 視窗 -->
                <!-- 編輯按鈕 -->
                <!-- <div
                  v-if="!editReviewContent"
                  class="editBtn"
                  @click="
                    editReviewContent = !editReviewContent;
                    dialog = !dialog;
                  "
                  key="editBtn"
                >
                  編輯
                </div> -->
                <!-- 內容(回顧)(僅檢視) (非邊時顯示)-->
                <!-- <div v-if="!editReviewContent" class="reviewContent" key="reviewContent">” {{ reviewContent }} ”</div> -->

                <!-- Feedback 區域 -->
                <div class="feedback-wrap" key="feedback">
                  <div class="feedback-title">
                    得到上述這位朋友<br>
                    分享的想法後
                  </div>
                  <div class="feedback-area">
                    <div class="feedback-option">
                      <div class="feedback-label">
                        讓我感同身受
                      </div>
                      <v-rating
                        empty-icon="mdi-star-outline"
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                        hover
                        length="5"
                        size="14"
                        :value="rating1 < 0 ? 0 : rating1"
                        @input="btnUpdateRating(1, $event)"
                      >
                        <template v-slot:item="props">
                          <v-icon
                            color="red lighten-2"
                            large
                            @click="props.click"
                          >
                            {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
                          </v-icon>
                        </template>
                      </v-rating>
                    </div>
                    <div class="feedback-option">
                      <div class="feedback-label">
                        對我很有幫助
                      </div>
                      <v-rating
                        empty-icon="mdi-star-outline"
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                        hover
                        length="5"
                        size="14"
                        :value="rating2 < 0 ? 0 : rating2"
                        @input="btnUpdateRating(2, $event)"
                      >
                        <template v-slot:item="props">
                          <v-icon
                            color="light-green"
                            large
                            @click="props.click"
                          >
                            {{ props.isFilled ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
                          </v-icon>
                        </template>
                      </v-rating>
                    </div>
                    <!-- <button class="btn-img" @click="btnUpdateFeedback(1)">
                      <img class="feedback-img" src="../assets/mind524/img/feed-back-1.svg" alt=""/>
                    </button>
                    <button class="btn-img" @click="btnUpdateFeedback(2)">
                      <img class="feedback-img" src="../assets/mind524/img/feed-back-2.svg" alt=""/>
                    </button> -->
                  </div>
                </div>
                <!-- 編輯彈跳窗 -->
                <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" key="dialog">
                  <div class="saveBtn" @click="saveEditContent()">
                    儲存
                  </div>
                  <!-- 編輯內容(回顧)輸入框 -->
                  <textarea v-if="editReviewContent" class="editReviewContent reviewContent" rows="4" cols="50" v-model="reviewContent" key="editReviewContent"></textarea>
                </v-dialog>
              </transition-group>
              <!-- 播放器上面的文字 -->
              <template v-if="showReplyAudio">
                <!-- 20210726 關閉底下唱片顯示 -->
                <!-- <div class="playerTitle" key="playerTitle">
                  你的內心顏色是
                  <span class="textRed">{{ playerTitle_2 }}</span>
                  ，象徵
                  <span class="textRed">{{ playerTitle_1 }}</span>
                  <br />
                  觸發了
                  <span class="textRed">{{ playerTitle_name }}</span>
                  的另一段旋律回音
                </div> -->
                <!-- 點擊播放器提示字 -->
                <!-- <div class="playerHintWord myRow items-center justify-center" key="playerHintWord"> -->
                  <!-- <img src="../assets/mind524/img/triangle-pink.png" alt="triangle-pink-icon" /> -->
                  <!-- <span>點擊下方唱片聆聽</span> -->
                  <!-- <img src="../assets/mind524/img/triangle-pink.png" alt="triangle-pink-icon" /> -->
                <!-- </div> -->
                <!-- 播放器的 icon -->
                <!-- <div class="playerIcon" @click="startPlayerMedia()" key="playerIcon"> -->
                  <!-- <div :class="[startPlayer ? 'bg-stop-player' : 'bg-start-player']"></div> -->
                  <!-- 散開來圈圈背景 -->
                  <!-- <CircleWave class="CircleWave-component" /> -->

                  <!-- 黃色圓圈，因播放器中間有洞，所以要補起來 -->
                  <!-- <div v-if="startPlayer" class="yellowCircle" key="yellowCircle"></div> -->
                  <!-- <div :class="[startPlayer ? 'bg-pause innerPauseIcon' : 'bg-play-white', 'innerIcon']"></div> -->
                  <!-- 重播鍵 -->
                  <!-- <div class="bg-replay replayResponseMedia" @click="replayPlayerMedia()"></div> -->

                <!-- </div> -->
              </template>
            </template>
          </transition-group>
          <transition name="slideDown">
            <M524BottomDrawer :height="80" :expend-height="140" :show.sync="bottomDrawer.show" v-show="rating1 >= 0 && rating2 >= 0 && feedbackMsgDialog.content && !feedbackMsgDialog.show">
              <div class="drawer-content">
                恭喜你完成本次練習 !
                <br />
                將納入你的個人成長報告結果中
                <br />
                <br />
                <button class="btn-replay-game" @click="replayGame">
                  <v-icon color="#FFF">mdi-replay</v-icon>
                  再挑戰一次
                </button>
              </div>
            </M524BottomDrawer>
          </transition>
          <!-- 音檔(不顯示) -->
          <audio v-show="false" :ref="'responseMedia'" controls :src="tempResponseMedia"></audio>
          <!-- 音檔(不顯示) -->
          <audio v-show="false" :ref="'playerMedia'" controls :src="playerMedia" key="playerMedia"></audio>
        </div>
      </transition-group>
      <FullscreenTextInputC2
        :width="stage.width"
        :height="stage.height"
        :top="0"
        :left="0"
        :show.sync="feedbackMsgDialog.show"
        :cancellable="false"

        title1="請分享為什麼會給予剛才的星星評分，是什麼影響了你的評分高低？"
        placeholder1="(點擊輸入回答，例如: 這表示我....)"

        title2="反思一下今天的練習，以下你有任何想要重新編輯、或額外補充的地方嗎？"
        placeholder2="(點擊輸入回答，例如: 這表示我....)"
        :default-value2="feedbackMsgDialog.content"
        background="#111D"
        @submit="onSubmitFeedbackMsg"
      >
        <div style="margin-top:20%; color:white; margin-bottom:16px;">
          深呼吸，經過今天的練習後，反思一下你剛剛分享給對方的話，以及共振夥伴的分享；有沒有甚麼其他內容想要重新編輯、或是額外多做分享的？
        </div>
      </FullscreenTextInputC2>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import FullscreenTextInputC2 from '@/components/FullscreenTextInputC2'
import ResponseWave from '../components/ResponseWave'
import CircleWave from '../components/CircleWave'
import textBgWave from '../components/textBgWave'
import M524BottomDrawer from '../components/M524BottomDrawer'
import testMedia from '../assets/media/11296260_MotionElements_heaven-piano_preview.mp3'
import { get } from 'lodash'
import {
  getS2PageData,
  updateS2PageData,
  updateReviewText,
  updateFeedback,
  updateFeedbackRating,
  updateFeedbackMsg
} from '../lib/mind524'

export default {
  name: 'ReponsePage',
  components: { FullscreenTextInputC2, ResponseWave, CircleWave, textBgWave, M524BottomDrawer },
  props: ['data'],
  data () {
    return {
      dialog: false,
      // 顯示各區塊
      showWave: false,
      showUp: false,
      showDown: false,
      // 回應的人的名字(最上面的變數)
      titleName: 'Amie',
      // 主要內容(黃色雲朵區塊)
      reponseContent: `我不滿意自己無法存款的習慣，這讓自己感到低人一等，沒辦法聰明、理性地安排生活，每隔一段時間就會出現帳單比預期數字多的狀況，讓生活處在暴露金錢危機的狀態。
          「每個人都有缺點，但換個角度看，缺點正是你的獨特之處。」
          也許，我可以從...
          我不滿意自己無法存款的習慣，這讓自己感到低人一等，沒辦法聰明、理性地安排生活，每隔一段時間就會出現帳單比預期數字多的狀況，讓生活處在暴露金錢危機的狀態。
          「每個人都有缺點，但換個角度看，缺點正是你的獨特之處。」
          也許，我可以從...`,
      // 是否播放回應音檔(上面的音檔)
      playResponse: false,
      // 音檔(回應)
      responseMedia: [testMedia],
      tempResponseMedia: '',
      tempResponseMediaIndex: 0,
      // 使用者名稱(波浪中標題中的變數)
      reviewText: '寅吃卯糧',
      // 內容(回顧)
      reviewContent: '這表示你懂得看見別人的付出，願意用金錢去肯定別人的努力。',

      // 顯示底下唱片相關的訊息
      showReplyAudio: false,

      // 播放器上面文字的變數1
      playerTitle_1: '平靜面對',
      // 播放器上面文字的變數2
      playerTitle_2: '夢境紫',
      playerTitle_name: 'Amie',
      // 是否播放回顧的音檔(下面的音檔)
      startPlayer: false,
      // 音檔(播放器)
      playerMedia: testMedia,
      // 是否正在編輯回顧的內容
      editReviewContent: false,
      // 表示選擇的 feedback 選項 (0=>未選擇, 其他數字=>不同的選項ID)
      feedback: 0,
      rating1: -1,
      rating2: -1,
      convId: '',
      storyId: '',

      // 主要畫面區域的大小
      stage: {
        height: 500,
        width: 400
      },

      feedbackMsgDialog: {
        show: false,
        content: '',
        content2: ''
      },

      bottomDrawer: {
        show: false
      }
    }
  },
  async mounted () {
    await this.updateS2PageContent()
    // 過濾空的連結
    this.responseMedia = (this.responseMedia || []).filter(audioSrc => !!audioSrc)
    if (this.responseMedia.length === 0) {
      this.responseMedia = [testMedia]
    }
    setTimeout(() => {
      this.showWave = true
    }, 300)
    setTimeout(() => {
      this.showUp = true
    }, 1000)
    setTimeout(() => {
      this.showDown = true
      this.playResponseMedia()
      // 210726 bottomDrawer 只在一開始決定要不要顯示
      // if (this.feedback !== 0) {
      //   this.bottomDrawer.show = true
      // }
      if (this.rating1 >= 0 && this.rating2 >= 0) {
        this.bottomDrawer.show = true
      }
    }, 1700)
    const myResponseMedia = this.$refs.responseMedia
    // 將音檔預設第一個
    this.tempResponseMedia = this.responseMedia[0]
    this.$onResponseMediaStop = () => {
      console.log(this.tempResponseMediaIndex)
      // 如果不是播最後一個音檔，則繼續播
      if (this.playResponse && this.tempResponseMediaIndex < this.responseMedia.length - 1) {
        this.tempResponseMedia = this.responseMedia[this.tempResponseMediaIndex + 1]
        this.tempResponseMediaIndex++
        myResponseMedia.play().catch(e => {
          this.playResponse = false
        })
        return
      }
      this.playResponse = false
      // 音檔改回之後要播放第一個
    }
    // 監聽音檔結束
    myResponseMedia.addEventListener('ended', this.$onResponseMediaStop, false)
    const playerMedia = this.$refs.playerMedia
    this.$onPlayerMediaStop = () => {
      this.startPlayer = false
    }
    // 監聽音檔結束
    playerMedia.addEventListener('ended', this.$onPlayerMediaStop, false)

    // 更新當前畫面的位置&大小資訊
    this.$nextTick(() => {
      this.updateStage()
    })
    setTimeout(() => {
      this.updateStage()
    }, 1700)
    window.addEventListener('resize', this.onWindowResize)
  },
  computed: {},
  watch: {
    dialog: function () {
      if (!this.dialog && this.editReviewContent) {
        this.editReviewContent = !this.editReviewContent
      }
    }
  },
  methods: {
    onWindowResize () {
      this.updateStage()
    },
    onSubmitFeedbackMsg ([content2, content]) {
      updateFeedbackMsg(this.convId, this.storyId, content, content2)
        .then(() => {
          this.feedbackMsgDialog.content = content
          this.feedbackMsgDialog.content2 = content2
          updateS2PageData({
            feedbackMsgDialog: {
              show: false,
              content,
              content2
            }
          })
          // 不須處理
        })
        .catch(() => {
          this.feedbackMsgDialog.content = ''
          this.$alert({
            type: 'error',
            content: 'feedback message 上傳失敗'
          })
        })
    },
    updateStage () {
      const e = this.$refs['main-screen']
      this.stage.width = e.clientWidth
      this.stage.height = e.clientHeight
    },
    // 更新頁面資訊
    async updateS2PageContent () {
      const data = await getS2PageData()
      Object.assign(this, data)
    },
    // 保存編輯的結果 & 關閉彈出視窗
    async saveEditContent () {
      if (this.convId && this.storyId) {
        await updateS2PageData({ reviewContent: this.reviewContent })
        await updateReviewText(this.convId, this.storyId, this.reviewContent)
      }
      this.editReviewContent = false
      this.dialog = false
    },
    async btnUpdateFeedback (feedback) {
      // const feedbackStr = feedback === 1 ? '感同身受' : '需要解惑'
      try {
        await updateFeedback(this.convId, this.storyId, feedback)
        await updateS2PageData({ feedback })
        this.feedback = feedback
        // this.$alert({
        //   type: 'info',
        //   content: `已選擇 "${feedbackStr}"`
        // })
      } catch (e) {
        const responseMsg = get(e, 'response.data.message')
        const rFeedback = get(e, 'response.data.feedback')
        if (rFeedback) {
          const feedbackStr = rFeedback === 1 ? '感同身受' : '需要解惑'
          this.$alert({
            type: 'warning',
            content: `已選擇 "${feedbackStr}"`
          })
          await updateS2PageData({ feedback: rFeedback })
          this.feedback = rFeedback
        } else if (responseMsg) {
          this.$alert({
            type: 'error',
            content: responseMsg
          })
        } else {
          this.$alert({
            type: 'error',
            content: 'feedback 失敗'
          })
          console.error(e)
        }
      }
      // 210726 bottomDrawer 只在一開始決定要不要顯示
      // if (this.feedback !== 0) {
      //   this.bottomDrawer.show = true
      // }
    },
    async btnUpdateRating (place, rating) {
      console.log('btnUpdateRating', place, rating)
      if (place === 1) {
        this.rating1 = rating
      } else if (place === 2) {
        this.rating2 = rating
      }
      if (this.rating1 >= 0 && this.rating2 >= 0) {
        try {
          await updateFeedbackRating(
            this.convId,
            this.storyId,
            this.rating1,
            this.rating2
          )
          await updateS2PageData({
            rating1: this.rating1,
            rating2: this.rating2
          })
          if (
            this.rating1 &&
            this.rating2 &&
            !this.feedbackMsgDialog.content
          ) {
            this.feedbackMsgDialog.show = true
            this.feedbackMsgDialog.content = this.reviewContent
            window.scrollTo(0, 0)
          }
          // this.$alert({
          //   type: 'info',
          //   content: '評分更新成功'
          // })
        } catch (e) {
          this.$alert({
            type: 'error',
            content: '設定評分失敗'
          })
          console.error(e)
        }
      }
    },
    // 播放或暫停回應音檔
    playResponseMedia () {
      console.log('playResponseMedia')
      if (!this.playResponse) {
        const myAudio = this.$refs.responseMedia
        console.log('call play')
        this.playResponse = true
        myAudio.play().catch(e => {
          this.playResponse = false
        })
      } else {
        console.log('call pause')
        const myAudio = this.$refs.responseMedia
        myAudio.pause()
        this.playResponse = false
      }
    },
    // 重播音檔
    replayResponseMedia () {
      const myAudio = this.$refs.responseMedia
      this.tempResponseMedia = this.responseMedia[0]
      this.tempResponseMediaIndex = 0
      myAudio.currentTime = 0
      myAudio.play().catch(e => {
        this.playResponse = false
      })
      this.playResponse = true
    },
    // 播放或暫停播放器音檔
    startPlayerMedia () {
      if (!this.startPlayer) {
        const myAudio = this.$refs.playerMedia
        myAudio.play().catch(e => {
          this.playResponse = false
        })
      } else {
        const myAudio = this.$refs.playerMedia
        myAudio.currentTime = 0
        myAudio.pause()
      }
      this.startPlayer = !this.startPlayer
    },
    // 重播音檔
    replayPlayerMedia () {
      const myAudio = this.$refs.playerMedia
      myAudio.currentTime = 0
      myAudio.play().catch(e => {
        this.playResponse = false
      })
      this.playResponse = true
    },
    replayGame () {
      window.location.href = '/mind524'
    }
  },
  beforeDestroy () {
    const myResponseMedia = this.$refs.responseMedia
    if (myResponseMedia) {
      myResponseMedia.pause()
    }
    myResponseMedia.removeEventListener('ended', this.$onResponseMediaStop, false)
    const playerMedia = this.$refs.playerMedia
    if (playerMedia) {
      playerMedia.pause()
    }
    playerMedia.removeEventListener('ended', this.$onPlayerMediaStop, false)
    this.$onResponseMediaStop = null
    this.$onPlayerMediaStop = null
    window.removeEventListener('resize', this.onWindowResize)
  }
}
</script>
<style scoped lang="scss">
// 頁面要加長兩個屬性都要加
$page-height: 880px;
$wave-content-height: 380px;

.myRow {
  display: flex;
  flex-wrap: wrap;
}
.myColumn {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
@mixin mini_scroll {
  &::-webkit-scrollbar {
    width: 5px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #f5c443;
    border-radius: 7px;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #f5c443;
  }
}
.ReponsePage-wrap {
  background-image: url('../assets/mind524/img/window-background.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: $page-height;
  width: 100vw;
  box-sizing: border-box;
}
.page-wrap {
  height: 100%;
  max-width: 414px;
  margin: 0 auto;
  background-color: #f5eef7;
  position: relative;
  overflow-x: hidden;
}
.pageTitle {
  font-size: 16px;
  padding-top: 34px;
  padding-bottom: 18px;
  text-align: center;
  .titleName {
    color: #ee5f7f;
  }
}
.mainContent-wrap {
  background-image: url('../assets/mind524/img/bg-yellow.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 91.73%;
  height: 254px;
  line-height: 21px;
  color: #202042;
  margin: 0 auto;
  padding: 55px 47px;
  position: relative;
}
.textBgWave-component {
  position: absolute;
  top: 92px;
  left: 50%;
  padding-top: 35px;
  overflow: hidden;
  height: 252px;
  width: 115%;
  border-radius: 37%;
  transform: translateX(-50%);
}
.mainContent {
  overflow-y: auto;
  height: 147px;
  @include mini_scroll;
  position: absolute;
  top: 55px;
  left: 41px;
  width: 77.73%;
  font-size: 14px;
  color: rgba(32, 32, 66, 1);
}
.ResponseWave-component {
  width: 100%;
  bottom: $wave-content-height;
}
.waveContent {
  position: absolute;
  height: $wave-content-height;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, #806ecb 0%, #b9d0fb 41.67%, #ffffff 79.17%, #ffffff 99.97%, #ffffff 99.98%, #5164a6 99.99%, #fafafa 100%),
    linear-gradient(180deg, #1d1b82 0%, #fad4fd 34.9%, #ffffff 68.23%, #ffffff 99.97%, #ffffff 99.98%, #5164a6 99.99%, #fafafa 100%);
}
.reviewTitle {
  padding: 10px 0 23px 21px;
  font-size: 12px;
  font-weight: 700;
  .reviewText {
    color: #504ea9;
  }
}
.editBtn,
.saveBtn {
  width: 44px;
  height: 24.86px;
  color: #fff;
  margin: -41px 11% -15px auto;
  text-align: center;
  font-size: 10px;
  line-height: 24px;
  cursor: pointer;
  background: #b4c7f7;
  border-radius: 3px;
}
.saveBtn {
  margin: 100px 14.27% -2px auto;
}
.feedback-wrap{
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #000D;
  .feedback-area{
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-around;
  }
  .feedback-img{
    width: 70px;
    height: 55px;
  }
  .feedback-option{
    margin-top: 20px;
  }
  .feedback-title{
    color: #353434;
    margin-top: 20px;
    font-size: 14px;
  }
  .btn-img{
  }
  .btn-img:hover{
    opacity: 0.8;
  }
  .btn-img:active{
    opacity: 0.5;
  }
}
.reviewContent {
  overflow-y: auto;
  overflow-x: hidden;
  height: 62px;
  width: 71.46%;
  color: #484ba4;
  font-size: 18px;
  line-height: 23px;
  padding: 8px 2px;
  margin: 17px auto 30px auto;
  @include mini_scroll;
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #efeff0;
    height: 44px;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #efeff0;
  }
  &.editReviewContent {
    outline: none;
    color: #000000;
    background: #e7e7e7;
    display: block;
    padding: 10px;
    height: 170px;
    resize: none;
    border-radius: 10px;
  }
}
.playerHintWord {
  font-size: 12px;
  position: relative;
  width: 151px;
  text-align: center;
  margin: 0 auto 20px auto;
  &::after {
    content: ' ';
    border-bottom: 4px solid rgba(238, 95, 127, 0.5);
    width: 102px;
    height: 2px;
    position: absolute;
    bottom: 1px;
    left: 24px;
  }
}
.playerTitle {
  font-size: 12px;
  line-height: 20px;
  color: #2d234c;
  margin: 0 auto;
  padding: 16px 20px 7px 20px;
  text-align: center;
  .textDarkPurple {
    color: #2d234c;
  }
  .textRed {
    color: #ee5f7f;
  }
}
.playerIcon {
  margin: 0 auto;
  position: relative;
  height: 116px;
  .innerIcon {
    position: absolute;
    top: 44%;
    left: calc(50% - 5px);
    z-index: 10;
  }
  .innerPauseIcon {
    top: 44px;
    left: calc(50% - 22px);
  }
  .yellowCircle {
    position: absolute;
    height: 20px;
    width: 20px;
    top: 42%;
    left: calc(50% - 10px);
    background: #f5d470;
    z-index: 5;
  }
  .CircleWave-component {
    position: absolute;
    transform: scale(0.75) translateX(-50%);
    left: calc(50% - 24px);
    top: -40px;
  }
}
// 粉紅色小生物
.bg-pink-animal {
  width: 63px;
  height: 65px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -10px -218px;
  // 位置
  margin: 28px auto 0 auto;
}
// 重播鍵
.bg-replay {
  // width: 40px;
  // height: 41px;
  width: 25px;
  height: 25.34px;
  // background: url("../assets/mind524/img/css_sprites_responsePage.png") -155px -218px;
  background-image: url('../assets/mind524/img/replay.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  // 位置
  position: absolute;
  left: 60%;
  bottom: -7px;
  cursor: pointer;
  &.replayResponseMedia {
    left: calc(60% - -18px);
    bottom: 44px;
    z-index: 10;
  }
}
// 含有播放的播放器
.bg-start-player {
  width: 118px;
  height: 119px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -263px -28px;
  cursor: pointer;
  // 位置
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  z-index: 2;
}
// 含有暫停的播放器
.bg-stop-player {
  width: 157px;
  height: 117px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -24px -49px;
  cursor: pointer;
  // 位置
  left: calc(50% - 20px);
  transform: translateX(-50%);
  position: absolute;
  z-index: 2;
}
// 白色播放 icon
.bg-play-white {
  width: 16px;
  height: 17px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -395px -218px;
  cursor: pointer;
}
// 儲存 icon
.bg-save-btn {
  width: 44px;
  height: 29px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -215px -218px;
  cursor: pointer;
  // 位置
  margin: 100px 14.27% -2px auto;
  background-color: rgba(250, 250, 250, 0.8);
  border-radius: 4px;
}
// 編輯 icon
.bg-edit {
  width: 23px;
  height: 23px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -279px -218px;
  // 位置
  margin-left: 32px;
  cursor: pointer;
}
// 粉色播放 icon
.bg-play-pink {
  width: 18px;
  height: 22px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -322px -218px;
  // 位置
  margin: 7px 14px;
  cursor: pointer;
}
// 白色暫停 icon
.bg-pause {
  width: 15px;
  height: 19px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -360px -218px;
  // 位置
  margin: 7px 14px;
  cursor: pointer;
}
// 愛心 icon
.bg-heart {
  width: 42px;
  height: 42px;
  background: url('../assets/mind524/img/css_sprites_responsePage.png') -93px -218px;
  // 位置
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  line-height: 42px;
  text-align: center;
  cursor: pointer;
}
// fade in 動畫
.fade-enter-active {
  transition: opacity 0.8s;
}
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
// slideDown 的動畫
.slideDown-enter-active,
.slideDown-enter-active {
  transition: all 1s ease;
}
.slideDown-enter,
.slideUp-leave-to {
  transform: translateY(-20%);
  opacity: 0;
}
// slideUp 的動畫
.slideUp-enter-active,
.slideUp-leave-active {
  transition: all 0.8s ease;
}
.slideUp-enter,
.slideUp-leave-to {
  transform: translateY(20%);
  // opacity: 0;
}
// slideIn 的動畫
.slideIn-enter-active {
  transition: all 1s ease;
}
.slideIn-leave-active {
  transition: all 0.3s ease;
}
.slideIn-enter {
  transform: translateX(310%);
  opacity: 0;
}
.slideIn-leave-to {
  transform: translateY(0%);
  opacity: 0;
}
</style>
<style lang="scss">
.ReponsePage-wrap {
  font-family: mind524-font, serif;
  .v-dialog.v-dialog--active {
    min-height: 455px;
    background: linear-gradient(180deg, #806ecb 0%, #b9d0fb 41.67%, #ffffff 79.17%, #ffffff 99.97%, #ffffff 99.98%, #5164a6 99.99%, #fafafa 100%),
      linear-gradient(180deg, #1d1b82 0%, #fad4fd 34.9%, #ffffff 68.23%, #ffffff 99.97%, #ffffff 99.98%, #5164a6 99.99%, #fafafa 100%);
  }
}
.drawer-content {
  text-align: center;
  color: #323232;
  .btn-replay-game {
    padding: 4px 20px 4px 20px;
    background-color: #4e4da8;
    border-radius: 8px;
    color: white;
  }
}
</style>
